import React from "react";
import {
  Responsive,
  List,
  SimpleList,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  Filter,
  ArrayField,
  SingleFieldList,
  ChipField,
  DateInput,
  ReferenceInput,
  SelectInput
} from "react-admin";
import { PesajeMaterialEditComponent } from "../components/PesajeMaterial/PesajeMaterialEditComponent.js";
import { PesajeMaterialCreateComponent } from "../components/PesajeMaterial/PesajeMaterialCreateComponent.js";
import { cloneElement } from 'react'
import { turnos } from '../utils';

export const StringToLabelObject = ({ record, children, ...rest }) =>
  cloneElement(children, {
    record: { label: record },
    ...rest,
  })

const PesajeMaterialFilters = props => {
  return (
    <Filter {...props}>
      <DateInput label="Fecha inicio" source="inicio" />
      <SelectInput label="Turno" source="turno" choices={ turnos } />
      <ReferenceInput reference="operarios" source="operario" sort={{ field: 'nombre', order: 'ASC' }}>
        <SelectInput  optionText="nombre" optionValue="_id" />
      </ReferenceInput>
    </Filter>
  );
};

export const PesajeMaterialList = props => (
  <List {...props} bulkActions={false} filters={<PesajeMaterialFilters />} exporter={false}>
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.pesadorNombre }
          secondaryText={record => `Fardo inicial: ${record.fardoInicial}`}
          terciaryText={record => `Fecha: ${record.inicio}`}
        />
      }
      medium={
        <Datagrid>
          <TextField label="Turno" source="turno" />
          <TextField label="Pesador Nombre" source="pesadorNombre" />
          <TextField label="Inicio" source="inicio" />
          <TextField label="Fin" source="fin" />
          <TextField label="Etapas" source="etapas" />
          <TextField label="Fardo Inicial" source="fardoInicial" />
          <TextField label="Fardo Final" source="fardoFina" />
        </Datagrid>
      }
    />
  </List>
);

export const PesajeMaterialCreate = props => {
  return (
    <PesajeMaterialCreateComponent {...props}/>
  );
};

export const PesajeMaterialEdit = props => {
  return (
    <PesajeMaterialEditComponent {...props}/>
  );
};

export const PesajeMaterialEditableList = props => (
  <List
    title="Lista de Pesajes de Materiales"
    {...props}
    bulkActions={false}
    filters={<PesajeMaterialFilters />}
    exporter={false}
    sort={{ field: "fecha", order: "DESC" }}
  >
    <Responsive
      small={
        <SimpleList
          primaryText={record => record.pesadorNombre }
          secondaryText={record => `Fardo inicial: ${record.fardoInicial}`}
          terciaryText={record => `Fecha: ${record.inicio}`}
        />
      }
      medium={
        <Datagrid>
          <TextField label="Turno" source="turno" />
          <TextField label="Pesador Nombre" source="pesadorNombre" />
          <DateField label="Inicio" source="inicio" />
          <DateField label="Fin" source="fin" />
          <ArrayField source="etapas">
             <SingleFieldList>
              <StringToLabelObject>
                  <ChipField source="label" />
              </StringToLabelObject>
            </SingleFieldList>
          </ArrayField>
          <TextField label="Fardo Inicial" source="fardoInicial" />
          <TextField label="Fardo Final" source="fardoFinal" />
          <EditButton />
        </Datagrid>
      }
    />
  </List>
);



// WEBPACK FOOTER //
// ./src/services/pesaje-material.js